import { createSelector } from '@reduxjs/toolkit';
import { IPaymentSummary } from 'shared/repositories/dailyrent/entities/payment_summary/PaymentSummary';
import { IPriceInfo } from 'shared/repositories/dailyrent/entities/response/PriceInfo';
import { IState } from 'shared/store';
import { TPaymentSummaryWithDiscount } from 'shared/types/dailyrent';

export const selectDailyrentBookingGeneral = (state: IState) => {
  return state.dailyrentBooking.general;
};
export const selectDailyrentBookingCalendar = (state: IState) => {
  return state.dailyrentBooking.calendar;
};
export const selectDailyrentBookingGuests = (state: IState) => {
  return state.dailyrentBooking.guests;
};

const selectPaymentSummary = (state: IState): IPaymentSummary | undefined => {
  return state.dailyrentBooking.general.paymentSummary;
};

const selectPriceInfo = (state: IState): IPriceInfo | undefined => {
  return state.dailyrentBooking.general.priceInfo;
};

export const selectPaymentSummaryWithDiscount = createSelector(
  [selectPaymentSummary, selectPriceInfo],
  (paymentSummary, priceInfo): TPaymentSummaryWithDiscount | null => {
    if (!paymentSummary || !priceInfo) {
      return null;
    }

    return {
      ...paymentSummary,
      headLine: {
        ...paymentSummary.headLine,
        originalPrice: priceInfo.originalPrice || '',
        discountPercent: priceInfo.discountPercent || '',
      },
    };
  },
);
